// ISO 639-1 code → endonym (native name) for languages in OpenAlex
export default {
  aa: "Afaraf",
  ab: "\u0410\u04A7\u0441\u0443\u0430",
  af: "Afrikaans",
  ak: "Akan",
  am: "\u12A0\u121B\u122D\u129B",
  an: "Aragon\u00E9s",
  ar: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
  as: "\u0985\u09B8\u09AE\u09C0\u09AF\u09BC\u09BE",
  av: "\u0410\u0432\u0430\u0440",
  ay: "Aymar aru",
  az: "Az\u0259rbaycan dili",
  ba: "\u0411\u0430\u0448\u04A1\u043E\u0440\u0442",
  be: "\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u043A\u0430\u044F",
  bg: "\u0411\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438",
  bh: "\u092D\u094B\u091C\u092A\u0941\u0930\u0940",
  bi: "Bislama",
  bm: "Bamanankan",
  bn: "\u09AC\u09BE\u0982\u09B2\u09BE",
  bo: "\u0F56\u0F7C\u0F51\u0F0B\u0F61\u0F72\u0F42",
  br: "Brezhoneg",
  bs: "Bosanski",
  ca: "Catal\u00E0",
  ce: "\u041D\u043E\u0445\u0447\u0438\u0439\u043D",
  ch: "Chamoru",
  co: "Corsu",
  cr: "\u14C0\u1426\u1403\u152D\u140D\u140F\u1423",
  cs: "\u010Ce\u0161tina",
  cu: "\u0421\u043B\u043E\u0432\u0463\u043D\u044C\u0441\u043A\u044A",
  cv: "\u0427\u04D1\u0432\u0430\u0448\u043B\u0430",
  cy: "Cymraeg",
  da: "Dansk",
  de: "Deutsch",
  dv: "\u078B\u07A8\u0788\u07AC\u0780\u07A8",
  dz: "\u0F62\u0FAB\u0F7C\u0F44\u0F0B\u0F41",
  ee: "E\u028Begbe",
  el: "\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC",
  en: "English",
  eo: "Esperanto",
  es: "Espa\u00F1ol",
  et: "Eesti",
  eu: "Euskara",
  fa: "\u0641\u0627\u0631\u0633\u06CC",
  ff: "Fulfulde",
  fi: "Suomi",
  fj: "Vosa Vakaviti",
  fo: "F\u00F8royskt",
  fr: "Fran\u00E7ais",
  fy: "Frysk",
  ga: "Gaeilge",
  gd: "G\u00E0idhlig",
  gl: "Galego",
  gn: "Ava\u00F1e'\u1EBD",
  gu: "\u0A97\u0AC1\u0A9C\u0AB0\u0ABE\u0AA4\u0AC0",
  gv: "Gaelg",
  ha: "Hausa",
  he: "\u05E2\u05D1\u05E8\u05D9\u05EA",
  hi: "\u0939\u093F\u0928\u094D\u0926\u0940",
  ho: "Hiri Motu",
  hr: "Hrvatski",
  ht: "Krey\u00F2l ayisyen",
  hu: "Magyar",
  hy: "\u0540\u0561\u0575\u0565\u0580\u0565\u0576",
  hz: "Otjiherero",
  ia: "Interlingua",
  id: "Bahasa Indonesia",
  ie: "Interlingue",
  ig: "Igbo",
  ii: "\ua188\ua320\ua259",
  ik: "I\u00F1upiaq",
  io: "Ido",
  is: "\u00CDslenska",
  it: "Italiano",
  iu: "\u1403\u14C4\u1483\u144E\u1450\u1466",
  ja: "\u65E5\u672C\u8A9E",
  jv: "Basa Jawa",
  ka: "\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8",
  kg: "KiKongo",
  ki: "G\u0129k\u0169y\u0169",
  kj: "Kuanyama",
  kk: "\u049A\u0430\u0437\u0430\u049B",
  kl: "Kalaallisut",
  km: "\u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A",
  kn: "\u0C95\u0CA8\u0CCD\u0CA8\u0CA1",
  ko: "\uD55C\uAD6D\uC5B4",
  kr: "Kanuri",
  ks: "\u0915\u0936\u094D\u092E\u0940\u0930\u0940",
  ku: "Kurd\u00EE",
  kv: "\u041A\u043E\u043C\u0438",
  kw: "Kernewek",
  ky: "\u041A\u044B\u0440\u0433\u044B\u0437\u0447\u0430",
  la: "Latina",
  lb: "L\u00EBtzebuergesch",
  lg: "Luganda",
  li: "Limburgs",
  ln: "Ling\u00E1la",
  lo: "\u0E9E\u0EB2\u0EAA\u0EB2\u0EA5\u0EB2\u0EA7",
  lt: "Lietuvi\u0173",
  lu: "Tshiluba",
  lv: "Latvie\u0161u",
  mg: "Malagasy",
  mh: "Kajin M\u0327aje\u013C",
  mi: "Te Reo M\u0101ori",
  mk: "\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438",
  ml: "\u0D2E\u0D32\u0D2F\u0D3E\u0D33\u0D02",
  mn: "\u041C\u043E\u043D\u0433\u043E\u043B",
  mr: "\u092E\u0930\u0930\u093E\u0920\u0940",
  ms: "Bahasa Melayu",
  mt: "Malti",
  my: "\u1019\u103C\u1014\u103A\u1019\u102C\u1018\u102C\u101E\u102C",
  na: "Ekakair\u0169 Naoero",
  nb: "Norsk bokm\u00E5l",
  nd: "isiNdebele",
  ne: "\u0928\u0947\u092A\u093E\u0932\u0940",
  ng: "Owambo",
  nl: "Nederlands",
  nn: "Norsk nynorsk",
  no: "Norsk",
  nr: "isiNdebele",
  nv: "Din\u00E9 bizaad",
  ny: "ChiChe\u0175a",
  oc: "Occitan",
  oj: "\u140A\u14C2\u1511\u14C8\u142F\u14A7\u140E\u14D0",
  om: "Afaan Oromoo",
  or: "\u0B13\u0B21\u0B3C\u0B3F\u0B06",
  os: "\u0418\u0440\u043E\u043D",
  pa: "\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40",
  pi: "\u092A\u093E\u0934\u093F",
  pl: "Polski",
  ps: "\u067E\u069A\u062A\u0648",
  pt: "Portugu\u00EAs",
  qu: "Runa Simi",
  rm: "Rumantsch",
  rn: "Ikirundi",
  ro: "Rom\u00E2n\u0103",
  ru: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
  rw: "Ikinyarwanda",
  sa: "\u0938\u0902\u0938\u094D\u0915\u0943\u0924\u092E\u094D",
  sc: "Sardu",
  sd: "\u0633\u0646\u068C\u064A",
  se: "Davvis\u00E1megiella",
  sg: "S\u00E4ng\u00F6",
  si: "\u0DC3\u0DD2\u0D82\u0DC4\u0DBD",
  sk: "Sloven\u010Dina",
  sl: "Sloven\u0161\u010Dina",
  sm: "Gagana Samoa",
  sn: "chiShona",
  so: "Soomaali",
  sq: "Shqip",
  sr: "\u0421\u0440\u043F\u0441\u043A\u0438",
  ss: "SiSwati",
  st: "Sesotho",
  su: "Basa Sunda",
  sv: "Svenska",
  sw: "Kiswahili",
  ta: "\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD",
  te: "\u0C24\u0C46\u0C32\u0C41\u0C17\u0C41",
  tg: "\u0422\u043E\u04B7\u0438\u043A\u04E3",
  th: "\u0E44\u0E17\u0E22",
  ti: "\u1275\u130D\u122D\u129B",
  tk: "T\u00FCrkmen",
  tl: "Tagalog",
  tn: "Setswana",
  to: "Faka Tonga",
  tr: "T\u00FCrk\u00E7e",
  ts: "Xitsonga",
  tt: "\u0422\u0430\u0442\u0430\u0440\u0447\u0430",
  tw: "Twi",
  ty: "Reo Tahiti",
  ug: "\u0626\u06C7\u064A\u063A\u06C7\u0631\u0686\u06D5",
  uk: "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430",
  ur: "\u0627\u0631\u062F\u0648",
  uz: "O\u02BBzbekcha",
  ve: "Tshiven\u1E13a",
  vi: "Ti\u1EBFng Vi\u1EC7t",
  vo: "Volap\u00FCk",
  wa: "Walon",
  wo: "Wollof",
  xh: "isiXhosa",
  yi: "\u05D9\u05D9\u05B4\u05D3\u05D9\u05E9",
  yo: "Yor\u00F9b\u00E1",
  za: "Sa\u026F cue\u014B\u0185",
  zh: "\u4E2D\u6587",
  zu: "isiZulu",
}
